/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * iCalendar frekvence opakování události
 *
 * Zdroje:
 * - [freq v iCalendar Recurrence Rule](https://tools.ietf.org/html/rfc5545#section-3.3.10)
 * @enum {string}
 */
const IcalFreq = {
  Secondly: 'SECONDLY',
  Minutely: 'MINUTELY',
  Hourly: 'HOURLY',
  Daily: 'DAILY',
  Weekly: 'WEEKLY',
  Monthly: 'MONTHLY',
  Yearly: 'YEARLY'
};

export default IcalFreq;
